import PropTypes from 'prop-types';
import { ALL_CATERING_FULFILLMENT_METHODS } from 'constants/fulfillmentOptions';

export const CATERING_FULFILLMENT_OPTIONS_PROPTYPES = PropTypes.arrayOf(
  PropTypes.oneOf(ALL_CATERING_FULFILLMENT_METHODS)
);

export const CATERING_FULFILLMENT_METHOD_PROPTYPES = PropTypes.oneOf(
  ALL_CATERING_FULFILLMENT_METHODS
);
